console.info("collections.js included");

$(".filter-list").on("change", ":checkbox", function() {
	console.log("Click on filter category tag");
	var checked = $(this).prop("checked");
	console.debug($(this).val() + (checked ? " checked" : " unchecked"));
	refreshProducts();
});
var refreshingProducts = false;
function refreshProducts() {
	console.info("refreshProducts()");
	if (refreshingProducts) {
		console.warn("Already refreshing...");
		return;
	}
	refreshingProducts = true;
	$(".filter-list :checkbox").attr("disabled", "disabled");
	$checkedTags = $("[name=catalog-filter]:checked");
	console.debug($checkedTags.length + " tags selected");
	var url = "/collections/all/";
	var selectedTags = [];
	$("[name=catalog-filter]:checked").each(function() {
		selectedTags.push($(this).val().replace(/\s/g, "-"));
	});
	url += selectedTags.join("+");

	var docTitle = "";
	console.debug(selectedTags);
	for (var i = 0; i < selectedTags.length; i++) {
		if (selectedTags[i].indexOf("Category:") != -1) {
			docTitle = selectedTags[i].replace("Category:-", "");
			break;
		}
	}
	for (var i = 0; i < selectedTags.length; i++) {
		if (selectedTags[i].indexOf("Collection:") != -1) {
			docTitle = selectedTags[i].replace(/Collection:-(.*)/, "$1");
			docTitle = docTitle.replace("-", " ") + " Collection";
			break;
		}
	}
	console.debug("docTitle = " + docTitle);

	// Add Sort By attribute to URL
	url += "?sort_by=" + $("[name=sort_by]").val();

	var pageFromUrl = location.href.match(/page=\d+/);
	if (pageFromUrl && pageFromUrl.length) {
		url += "&" + pageFromUrl;
	}

	console.log("ajaxUrl = " + url);

	// Update current URL
	docTitle = docTitle.length ? docTitle : "Catalog";
	$(".page-title h1").html(docTitle);
	docTitle += " &ndash; JEWELv";
	history.pushState(null, docTitle, url);
	$("title").html(docTitle);

	// AJAX request
	$.ajax({
		type: "GET",
		url: url
	}).done(function(response) {
		$resp = $(response);
		$(".catalog").html($resp.find(".catalog").html());
        
      	$(".thumbnail img, .cart_page_image img").unveil(400, function() {
          $(this).load(function() {
            this.style.opacity = 1;
          });
        });

		// Update available filter options
		$filterList = $resp.find(".filter-list");
		updateAvailableFilterOptions($(".filter-list"), $filterList);

		if ($resp.find(".category-banner").length) { // If has Category Banner
			if ($(".category-banner").length) {
				$(".category-banner").replaceWith($resp.find(".category-banner"));
			} else {
				$(".title-with-filter").before($resp.find(".category-banner"));
			}
		} else {
			if ($(".category-banner").length) {
				$(".category-banner").remove();
			}
		}

	}).always(function() {
		refreshingProducts = false;
	});
}
function updateFilter() {
	console.info("updateFilter()");
	$.ajax({
		type: "GET",
		url: "/collections/all/",
		data: ""
	}).done(function(response) {
		$resp = $(response);
		$was = $(".filter-list").clone();
		$(".filter-list").html($resp.find(".filter-list").html());
		updateAvailableFilterOptions($resp.find(".filter-list"), $was);
	});
}
updateFilter();

function updateAvailableFilterOptions($source, $responseFilterList) {
	$(".filter-list").find(":checkbox").each(function() {
		if ($responseFilterList.find("#" + $(this).attr("id")).length) {
			$(this).removeAttr("disabled").parent().css("opacity", 1);
			var path = location.pathname.replace(/-/g, " ");
			if (path.indexOf($(this).val()) != -1) {
				$(this).prop("checked", true);
			}
		} else {
			$(this).parent().css("opacity", 0.5);
		}
	});
}

$("[name=sort_by]").change(function() {
	console.log("Sort By changed.");
	refreshProducts();
});